import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Container, Row, Card, CardBody, CardTitle, Toast } from "reactstrap";
import { API_BASE_URL } from "../../constants";
import Breadcrumb from "../../components/Common/Breadcrumb";

const Buildings = () => {
  const [buildings, setBuildings] = useState([]);
  const toast = useRef(null);

  useEffect(() => {
    fetchBuildings();
  }, []);

  const fetchBuildings = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/buildings/list`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.data.status === "success" && Array.isArray(response.data.data)) {
        setBuildings(response.data.data);
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Unexpected response format",
          life: 3000,
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch buildings",
        life: 3000,
      });
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="Buildings" breadcrumbItems={[{ title: "School", link: "#" }, { title: "Buildings", link: "#" }]} />
        <div className="d-flex justify-content-between align-items-center mb-3">
          <p>Showing {buildings.length} buildings</p>
        </div>
        <Row>
          {buildings.length > 0 ? (
            buildings.map((building) => (
              <Card key={building.id} className="m-2" style={{ width: "18rem" }}>
                <CardBody>
                  <CardTitle tag="h5">{building.name}</CardTitle>
                </CardBody>
              </Card>
            ))
          ) : (
            <p>No buildings available</p>
          )}
        </Row>
      </Container>
      <Toast ref={toast} />
    </div>
  );
};

export default Buildings;
